<!-- horizontal layout -->
@if (isHorizontalLayoutRequested()) {
  <app-horizontal></app-horizontal>
}